var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { observer } from "mobx-react";
import { Modal, useModalStore } from "@wemogy/reactbase";
import SearchAndReplace from "../searchAndReplace/SearchAndReplace";
var SearchAndReplaceModal = function () {
    var modalStore = useModalStore();
    var parameters = modalStore.getActiveParameters("searchAndReplace");
    if (!parameters) {
        return null;
    }
    return (React.createElement(Modal, { modalKey: "searchAndReplace", title: "Suchen und Ersetzen (" + parameters.propertyName + ")" },
        React.createElement(SearchAndReplace, __assign({}, parameters))));
};
export default observer(SearchAndReplaceModal);
//# sourceMappingURL=SearchAndReplaceModal.js.map